import { isValid, parseISO } from 'date-fns';

/**
 * Parses an ISO 8601 API timestamp into a `Date`, or `null` when the value is
 * missing or unusable.
 *
 * API timestamps can be absent or malformed, and `date-fns` throws when asked
 * to format or parse those, so every date coming off the API should go through
 * here before it reaches `format` or a comparison.
 */
const parseDate = (value?: string | null): Date | null => {
  if (!value) {
    return null;
  }

  try {
    const parsed = parseISO(value);

    return isValid(parsed) ? parsed : null;
  } catch {
    // `parseISO` throws on non-string input, which callers bypassing the TS
    // type can still reach at runtime.
    return null;
  }
};

export default parseDate;
